import { useId } from 'react'

interface Props {
  name?: string
  label?: string
  type?: string
  placeholder?: string
  value?: string
  required?: boolean
  disabled?: boolean
  readOnly?: boolean
  hint?: string
  error?: string
  prefix?: string
  suffix?: string
  className?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onInput?: (e: React.FormEvent<HTMLInputElement>) => void
}

export function Input({
  name,
  label,
  type = 'text',
  placeholder = '',
  value,
  required = false,
  disabled = false,
  readOnly = false,
  hint = '',
  error = '',
  prefix,
  suffix,
  onChange,
  onInput,
  className = '',
}: Props) {
  const id = useId()
  const inputMode =
    type === 'number' || type === 'decimal' ? 'decimal' : type === 'tel' ? 'tel' : undefined

  return (
    <div className={`cf-field${error ? ' cf-field--error' : ''}`}>
      {label && (
        <label className='cf-field__label' htmlFor={id}>
          {label}
          {required && (
            <span className='cf-field__required' aria-hidden>
              {' '}
              *
            </span>
          )}
        </label>
      )}
      <div className='cf-field__input-wrap'>
        {prefix && (
          <span className='cf-field__prefix' aria-hidden>
            {prefix}
          </span>
        )}
        <input
          className={['cf-field__input', className].filter(Boolean).join(' ')}
          id={id}
          name={name}
          type={type}
          inputMode={inputMode}
          placeholder={placeholder}
          value={value}
          required={required}
          disabled={disabled}
          readOnly={readOnly}
          aria-describedby={hint || error ? `${id}-hint` : undefined}
          aria-invalid={error ? true : undefined}
          onChange={onChange}
          onInput={onInput}
        />
        {suffix && (
          <span className='cf-field__suffix' aria-hidden>
            {suffix}
          </span>
        )}
      </div>
      {(error || hint) && (
        <span className='cf-field__hint' id={`${id}-hint`} {...(error ? { role: 'alert' } : {})}>
          {error || hint}
        </span>
      )}
    </div>
  )
}
